const {EMPTY_URL} = require("src/csi/constants");
const ApparelBom = require('./Model/ApparelBom').default;

define([
	"csi/config",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/modules",
	"csi/action/FormData",
	"csi/core/ExtendedPath",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/QueryFilterBuilder",
	"./BOM/PartMaterialBOMSectionMixin",
	"./BOM/PartMaterialRequireSectionMixin",
	"Apparel/ProductType"
], function(config, declare, lang, csi, modules, FormData, ExtendedPath, NewFrom, ActionControllerMixin, xml,
			Query, QueryFilterBuilder, PartMaterialBOMSectionMixin, PartMaterialRequireSectionMixin, ProductType) {

	return declare([NewFrom, ActionControllerMixin, PartMaterialBOMSectionMixin, PartMaterialRequireSectionMixin], {
		// FormData: form data storing selected BOM and BOM Items
		_fdBom: null,
		_fdItems: null,

		/**
		 * @override
		 * Add property soft filter on NewFromThemeBOM action to  show only theme BOMs from the Same Theme Master as the user is on.
		 * @param {csi/wizard/Widget} wizard
		 * @param {Content} page
		 * @param {View} defView
		 * @param {Object} viewParams
		 */
		onWizardViewPreCreate: function(wizard, page, defView, viewParams) {
			if (wizard.getIndexOfPage(page) === 0) {
				if (this.m_action.m_id === "NewFromThemeBOM") {
					const key = xml.queryKey(xml.ATTR_NAME, null, xml.path("__Parent__", "__Parent__"));
					const themeMaster = this.m_cache.getPathNode(this.m_urlParent, "Child:__Parent__/Child:__Parent__/Child:__Parent__");
					viewParams.query = {[key]: [themeMaster.$Name]};
				}
			}
		},

		/**
		 * Prepare Wizard view query.
		 *
		 * @param {csi.wizard.Widget} wizard
		 * @param {csi.wizard.Widget} view
		 * @param {Number} index
		 * @returns {Query}
		 */
		getWizardViewQuery: function(wizard, view, index) {
			const q = new Query();
			const cache = this.m_cache;
			let product;
			if (ApparelBom.isSourceBOM(this.m_cache.getNode(this.getParent().__Parent__))) {
				product = cache.getPathNode(this.getParent(), "Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__");
			} else {
				product = cache.getPathNode(this.getParent(), "Child:__Parent__/Child:__Parent__");
			}

			if (wizard.defView.m_id === "NewFromProductBOMItems" && index === 0) {
				q.RefAttr("LinkedHostDataSheet", xml.OP_EQUALS, csi.EMPTY_URL);
			}

			if (index === 1) {
				if (product.$Type === "Style" || product.$Type === "Material") {

					const hasAppliedFilters = this._applyRequireSectionFiltersFromPartMaterial(q);

					if (!hasAppliedFilters && modules.hasModule("MaterialSpecProductSpec")) {
						// summary: filter out structured placements on page 2
						q.RefAttr("PSPlacement", xml.OP_EQUALS, csi.EMPTY_URL);
					}

					if (this.isFromTemplate && !ProductType.get(product, "IsAssortment")) {
						q.Attr("ForStyle", xml.OP_EQUALS, false);
					}
				}

				// C8FB-663: On FoodBOMRevision's 'New from BOM' action, display only FoodBOMLineItem's  which are allowed on FoodBOMSubtypeSettings.ItemsProductTypes
				if (product.$Type === "Food") {
					const bomSubtypeSettings = cache.getPathNode(this.getParent(), "Child:__Parent__/Child:Subtype/Child:Settings");
					const itemsProductTypes = bomSubtypeSettings ? bomSubtypeSettings.ItemsProductTypes : [];
					const cntItemsProductTypes = itemsProductTypes.length;
					const preference = [];
					for (let ind = 0; ind < cntItemsProductTypes; ind++) {
						preference.push(bomSubtypeSettings.ActualItemsSelectionPreference[itemsProductTypes[ind]].split(':')[1]);
					}
					if (cntItemsProductTypes !== 3 || preference.includes("BaseRealizedProduct")) {
						let qOr = q.Or();
						for (let ind = 0; ind < cntItemsProductTypes; ind++) {
							if (preference[ind] === "BaseRealizedProduct") {
								let qOrAnd = qOr.And();
								qOrAnd.Attr("ItemProductType", xml.OP_EQUALS, itemsProductTypes[ind]);
								qOrAnd.RefAttr("BOMLineSKU", xml.OP_NOT_EQUALS, EMPTY_URL);
							} else {
								qOr.Attr("ItemProductType", xml.OP_EQUALS, itemsProductTypes[ind]);
							}
						}
					}
				}
			}

			const qr = this.widget.getQueryResultByDomNode(this.refNode);

			const groupValue = qr.parentResult.groupValue;
			if (xml.isValidURL(groupValue)) {
				const bomSectionDef = cache.getNode(groupValue);

				// apply filters if the BOM section is not AdHoc. The type must be checked because table can be grouped by attributes other than BOM section
				if (bomSectionDef && bomSectionDef.$Type === "BOMSectionDefinition" && !bomSectionDef.AdHoc) {
					if (index === 0) {
						q.RefAttr("AllSections", xml.OP_EQUALS, bomSectionDef.$URL, "Child:CurrentRevision");
					} else {
						q.RefAttr("DSSection", xml.OP_EQUALS, bomSectionDef.$URL);
					}
				}

				// see if there is a query filter (it can't be AdHoc)
				const bomQueryFilter = bomSectionDef.QueryFilter;
				if (xml.isValidURL(bomQueryFilter) && index === 1) {
					const ep = ExtendedPath.create("PartMaterial", xml.path("Actual"));
					QueryFilterBuilder.createWithPrefixPath(q, ep, bomQueryFilter, groupValue, cache);
				}

				let groupProductType = this.widget.getActionElementGroupProductType(this);
				if (groupProductType && index === 1) {
					q.RefAttr("ProductType", xml.OP_EQUALS, groupProductType, xml.path("Actual"));
				}
			}

			return q;
		},

		preProcess: function() {
			// summary: cache form data for later
			this._fdItems = this._getPartMaterialFormData();
			this._fdBom = this._getBomFormData();

			lang.mixin(this._fdBom, {
				m_bOmitSelections: true,
				m_bRequireOne: true,
				m_bSelectOne: true
			});

			this.inherited(arguments);
		},

		/**
		 * Prepare the data and pass it into the next page
		 * @param {boolean} bFinish
		 * @param {csi.wizard.Content} currentPage
		 * @param {csi.wizard.Content} nextPage
		 * @param {csi.wizard.Widget} wizard
		 * @returns {*}
		 */
		onNextPage: function(wizard, currentPage, nextPage, bFinish) {
			let bRefresh = false;
			let dfd, fd;
			if (currentPage && nextPage) {
				// second (and last) page - show view of selected BOM's part materials
				const nodeBOM = wizard.getFormDataFromPage(currentPage).getSelectedNode();

				// the next page may already have form data if user used back button; if so,
				// then just use form data already there; otherwise, use wizard's form data for
				// last page since that is what will be fed into NewFrom controller for processing
				fd = this._fdItems;

				// if form data node has changed, then reset selections and refresh view
				if (fd.getNode() !== nodeBOM) {
					fd.resetSelections();
					fd.setNode(nodeBOM);
					bRefresh = true;
				}
			} else if (nextPage) {
				// first page - create form data to select single BOM
				fd = this._fdBom;
				fd.setNode(wizard.getViewNode());
			}

			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		isSelected: function() {
			return this.m_formData.getSelectedNodes().length > 0;
		},

		/** BOM - Disable the "Finish" button in the second form of "New From Style BOM" dialog, if there are no placements selected. */
		disableFinish: function(wizard, page, index) {
			return index === 0 || !this.isSelected();
		},

		/** use new form data to store bom selection */
		_getBomFormData: function() {
			return new FormData(this);
		},

		/** Use controller form data to store part material selections */
		_getPartMaterialFormData: function() {
			return this.getFormData();
		},

		/**
		 * disable Finish & Go
		 */
		_canNavigate: function() {
			return false;
		},

		postProcessSuccess() {
			const cache = this.getCache();
			const bom = cache.getNode(this.getParent().__Parent__);
			const isRequireSection = config.getSubtypeSetting(bom.Subtype, "RequireSectionForPlacement");
			if (isRequireSection) {
				this.widget.refreshData();
			} else {
				this.inherited(arguments);
			}
		},

		/* @override */
		getActionView: function(/*ViewRef?*/vr) {
			const action = this.m_action;
			const idView = action.m_viewRef.m_id;
			const isSourceBOM = ApparelBom.isSourceBOM(this.m_cache.getNode(this.getParent().__Parent__));
			if (idView === "NewFromProductBOMItems" && isSourceBOM) {
				action.m_viewRef.m_path = "Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__";
			}

			return this.inherited(arguments);
		}
	});
});